const Theme = {
    body_background_color: 'rgb(36,150,191)',
    title_font: 'Arial',
    text_font: 'Arial',
    logo_image_url: 'berceauducanadagaspe.png',
    header_full_height: true,
    header_no_margin: true,
    header_no_border: true,
    logo_full_width: true,
    button_border_width: 1,
    button_color: 'rgb(236, 176, 47)',
    button_radius: 100,
    title_margin: '10px',
    token_hidden: true,
    number_hidden: true,
  }
  
  export default Theme
  // https://app.clickup.com/t/86dtpzcn4